<script>
  import { defaults } from '../../../config';
  import Accordion from './index.svelte';
  import { clickToCopy } from '../../../util';

  export let form = null;
  export let open = false;

  $: formLink = `${defaults.formUrl}${form?.formLinkCode}`;

  function confirmCopy(ev) {
    ev.target.setAttribute('data-tooltip', 'Copied form link to clipboard!');
    setTimeout(() => {
      ev.target.removeAttribute('data-tooltip');
    }, 1000);
  }
</script>

<Accordion title="Builder" icon="code" {open}>
  <div slot="main">
    {#if form}
      <ul>
        <li>
          <a
            name="formLinkCopier"
            use:clickToCopy={formLink}
            on:click|preventDefault={confirmCopy}
            target="_blank"
            href="{formLink}"
          >
            {form.formLinkCode}
          </a>
        </li>
      </ul>
    {:else}
      <ul>
        <li>No form information to display</li>
      </ul>
    {/if}
  </div>
</Accordion>

<style>
  :global(:root) {
    --sub-bg: #eee;
    --sub-highlight: #ccc;
  }
  :global([data-theme='dark']) {
    --sub-bg: rgba(0, 0, 0, 0.3);
    --sub-highlight: #222;
  }
  ul {
    background: var(--sub-bg);
    border-radius: 6px;
    --color: var(--contrast);
    margin: 0 1.2rem 1.2rem;
    padding: 2rem;
  }
  li {
    list-style-type: none;
  }
</style>
